import React from 'react';
import Flatpickr from 'react-flatpickr'
import Chart from 'react-google-charts';
import DateFilter from '../DateFilter.js'
import GroupBy from '../GroupBy.js'

class Reporting extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			active: false,
			activeReport: false,
			activeCall: false,
			dateFilter: false,
			groupBy: false,
			playingRecording: false,
			extraData: false,
			recLoading: false,
			parameters: {},
			parameterList: [
				{
					"parameter": "application",
					"label": "Application",
					"type": "dynamic"
				},
				{
					"parameter": "type",
					"label": "Type",
					"type": "dynamic"
				},
				{
					"parameter": "start",
					"label": "Start Date/Time",
					"type": "datetime"
				},
				{
					"parameter": "end",
					"label": "End Date/Time",
					"type": "datetime"
				},
				{
					"parameter": "dateFilter",
					"label": "Filters",
					"type": "dateFilter"
				}
				//,
				// {
				// 	"parameter": "groupBy",
				// 	"label": "Groupings",
				// 	"type": "groupBy"
				// }
			]
		};
	}

	play = (call) => {
		this.setState({ playingRecording: true, activeCall: call }, function () {
			this.props.ws.send(JSON.stringify({ route: 'getTwilioRecording', call: this.state.activeCall }))
		})
	}
	viewExtraData = (data) => {
		console.log(data)
		console.log(decodeURIComponent(data))
		console.log(JSON.parse(decodeURIComponent(data)))
		this.setState({ extraData: JSON.parse(decodeURIComponent(data)) })
	}
	formatRecordingName = (call) => {
		var d = new Date(call.dateTime).toLocaleDateString().replace(/\//gm, '.')
		var t = new Date(call.dateTime).toLocaleTimeString().replace(/:.. /gm, '').replace(/:/gm, '.')
		var cid = call.callerID.replace(/\+1/gm, '')
		var phone = '(' + cid.slice(0, 3) + ')' + cid.slice(3, 6) + '-' + cid.slice(6, 10)

		return (d + '_' + t + '_' + phone + '.wav')
	}
	cancel = () => {
		this.setState({ dateFilter: false, groupBy: false, loading: false, viewingReportDetail: false, extraData: false, playingRecording: false, activeCall: false })
	}

	selectReport = (e) => {
		this.setState({ activeReport: JSON.parse(e.currentTarget.getAttribute('data-report')), parameters: {}, reportData: false })
	}

	cancelReport = (e) => {
		this.setState({ activeReport: false })
		this.props.ws.send(JSON.stringify({ route: 'newReport' }))
		this.forceUpdate()
	}

	updateReportParameter = (param, e) => {
		var newParameters = Object.assign({}, this.state.parameters)

		newParameters[param] = e.currentTarget.value
		this.setState({ parameters: newParameters })
	}

	updateDateParameter = (e, value) => {
		var newParameters = Object.assign({}, this.state.parameters)
		var date
		console.log('new date!')
		console.log(value[0])
		if (value[0]) {
			date = { datetime: value[0], offset: value[0].getTimezoneOffset() * 60000 }

		} else {
			date = undefined
		}

		newParameters[e] = date
		this.setState({ parameters: newParameters })
	}

	updateDateTimeParameter = (e, value) => {
		var newParameters = Object.assign({}, this.state.parameters)
		console.log('new date!')
		console.log(e)
		console.log(value)
		if (value[0]) {
			newParameters[e] = { datetime: value[0], offset: value[0].getTimezoneOffset() * 60000 }
		} else {
			newParameters[e] = undefined
		}
		//newParameters.offset = value[0].getTimezoneOffset() * 60000
		this.setState({ parameters: newParameters })
	}

	runReport = (exp, e) => {
		var reportParams = Object.assign({}, this.state.parameters)
		var date = new Date(); date.setMonth(0)
		reportParams.timeZone = /\((.*)\)/.exec(date.toString())[1]
		reportParams.route = "connectionReporting"
		reportParams.report = this.state.activeReport
		reportParams.exp = exp

		this.props.ws.send(JSON.stringify(reportParams))
	}


	displayDateFilter = (active) => (e) => {
		this.setState({ dateFilter: active })
	}
	displayGroupBy = (active) => (e) => {
		this.setState({ groupBy: active })
	}
	
	confirmDateFilter = (data) => {
		var newParams = Object.assign({}, this.state.parameters)
		newParams.dateFilter = data
		this.setState({ parameters: newParams, dateFilter: false })
	}
	confirmGroupBy = (data) => {
		var newParams = Object.assign({}, this.state.parameters)
		newParams.groupBy = data
		this.setState({ parameters: newParams, groupBy: false })
	}

	chartSelect = ({ chartWrapper }) => {
		if (this.props.data.reportType != "Detail") {
			return false
		}
		var connectionID = this.props.data.reportData.table.rows[chartWrapper.getChart().getSelection()[0].row][0]
		this.setState({ viewingReportDetail: true, loading: true })
		this.props.ws.send(JSON.stringify({ route: 'connectionDetail', connectionID: connectionID }))
	}
	convertSec(sec) {
		sec = Math.round(sec)
		var d, h, m, s;
		s = sec
		m = Math.floor(s / 60);
		s = s % 60;
		h = Math.floor(m / 60);
		m = m % 60;
		d = Math.floor(h / 24);
		h = h % 24;

		var time = ''

		d > 0 ? time += d + ' days, ' : time += ''
		h < 1 ? time += '' : h > 0 && h < 10 ? time += '0' + h + ':' : time += h + ':'
		m < 1 ? time += '00:' : m < 10 ? time += '0' + m + ':' : time += m + ':'
		s < 1 ? time += '00' : s < 10 ? time += '0' + s : time += s

		return time;
	};
	formatPhoneNumber(num) {
		if (!num) { return false };
		if (num.length === 0) {
			return "No Number Available"
		} else if (num.length < 7) {
			return num;
		} else if (num.length === 7) {
			return (num.substring(0, 3) + '-' + num.substring(3, 7))
		} else if (num.length === 10) {
			return ('(' + num.substring(0, 3) + ') ' + num.substring(3, 6) + '-' + num.substring(6, 10))
		} else if (num.length === 11) {
			return ('(' + num.substring(1, 4) + ') ' + num.substring(4, 7) + '-' + num.substring(7, 11))
		} else if (num.length === 12) {
			return ('(' + num.substring(2, 5) + ') ' + num.substring(5, 8) + '-' + num.substring(8, 12))
		} else {
			return num;
		}
	}

	render() {
		if (this.props.active) {
			var activeReport = ""
			var row

			var paramHeaders = []
			var reportParams = []
			var choice
			var parameterOptions
			for (var parameter of this.state.parameterList) {
				paramHeaders.push(
					<div key={parameter.label}>{parameter.label}</div>
				)
				if (parameter.type === 'datetime') {
					reportParams.push(
						<Flatpickr key={parameter.label} data-enable-time options={{ dateFormat: "Y-m-d h:i K", defaultHour: 0, defaultMinute: 0, onValueUpdate: this.updateDateParameter.bind(this, parameter.parameter) }} value={this.state.parameters[parameter.parameter] ? this.state.parameters[parameter.parameter].datetime : null} />
					)
				} else if (parameter.type === 'date') {
					reportParams.push(
						<Flatpickr key={parameter.label} options={{ dateFormat: "Y-m-d h:i K", defaultHour: 0, defaultMinute: 0 }} value={!this.state.parameters[parameter.parameter] || this.state.parameters[parameter.parameter].datetime} onChange={this.updateDateParameter.bind(this, parameter.parameter)} />
					)
				} else if (parameter.type === 'text') {
					reportParams.push(
						<input key={parameter.label} type="text" value={this.state.parameters[parameter.parameter]} onChange={this.updateReportParameter.bind(this, parameter.parameter)} />
					)
				} else if (parameter.type === 'dateFilter') {
					var typeCount = 0
					var filterCount = 0
					for (var type in this.state.parameters[parameter.parameter]) {
						var typeUsed = false
						for (var param in this.state.parameters[parameter.parameter][type]) {
							if (this.state.parameters[parameter.parameter][type][param]) {
								filterCount++
								typeUsed = true
							}
						}
						if (typeUsed) {
							typeCount++
						}
					}
					var val = filterCount > 0 ? (filterCount + (filterCount > 1 ? ' Filters' : ' Filter') + ' in ' + typeCount + (typeCount > 1 ? ' Categories' : ' Category')) : ''
					console.log(val)
					reportParams.push(
						<input key={parameter.label} type="text" defaultValue={val} onFocus={this.displayDateFilter(true)} />
					)


				} else if (parameter.type === 'groupBy') {
					var typeList = []
					for (var type in this.state.parameters[parameter.parameter]) {
						if (this.state.parameters[parameter.parameter][type]) {
							typeList.push(type)
						}
					}

					reportParams.push(
						<input key={parameter.label} type="text" defaultValue={typeList.join(', ')} onFocus={this.displayGroupBy(true)} />
					)
				} else if (parameter.type === 'dropdown') {
					parameterOptions = [<option value={null} key="blankOption"></option>]
					for (choice of parameter.options) {
						parameterOptions.push(
							<option value={choice} key={choice}>{choice}</option>
						)
					}

					reportParams.push(
						<select key={parameter.label} onChange={this.updateReportParameter.bind(this, parameter.parameter)} value={this.state.parameters[parameter.parameter]}>
							{parameterOptions}
						</select>
					)
				} else if (parameter.type === 'dynamic') {
					if (this.props.data.dynamicParams && this.props.data.dynamicParams[parameter.parameter]) {
						parameterOptions = [<option value={null} key="blankOption"></option>]
						for (choice of this.props.data.dynamicParams[parameter.parameter]) {
							parameterOptions.push(
								<option value={choice.id} key={choice.id + choice.name}>{choice.name}</option>
							)
						}
						reportParams.push(
							<select key={parameter.label} onChange={this.updateReportParameter.bind(this, parameter.parameter)} value={this.state.parameters[parameter.parameter]}>
								{parameterOptions}
							</select>
						)
					} else {
						this.props.data.dynamicParams[parameter.parameter] = []
						this.props.ws.send(JSON.stringify({ route: 'getParam_' + parameter.parameter }))
						reportParams.push(
							<input key={parameter.label} type="text" value={this.state.parameters[parameter.parameter]} onChange={this.updateReportParameter.bind(this, parameter.parameter)} />
						)
					}
				}
			}
			paramHeaders.push(
				<div key="paramHeader"></div>
			)

			var report = []
			var rows, i, options, columns

			if (this.props.data.reportData) {
				if (this.props.data.reportData.graph) {
					if (this.props.data.reportData.graph.type === 'pie') {
						report.push(
							<div key="piechart">
								<h2 style={{ textAlign: 'center', color: '#2A6AA9' }}>{this.props.data.reportData.graph.title}</h2>
								<div className="mini-chart-container" style={{ display: 'inline-block', width: '100%', height: '40vh' }}>

									<Chart

										chartType="PieChart"
										columns={this.props.data.reportData.graph.columns}
										rows={this.props.data.reportData.graph.rows}
										options={
											{
												pieHole: 0,
												legend: 'labeled',
												sliceVisibilityThreshold: 0,
												pieStartAngle: 90,
												pieSliceTextStyle: { color: '#fff', fontSize: '1vw' },
												chartArea: { width: "90%", height: "90%" }
											}
										}
										graph_id="pieChart"
										height="100%"
										width="100%"
									/>
								</div>
							</div>
						)
					} else if (this.props.data.reportData.graph.type === 'bar') {
						rows = this.props.data.reportData.graph.rows.slice()

						for (i = 0; i < this.props.data.reportData.graph.columns.length; i++) {
							if (this.props.data.reportData.graph.columns[i].type === 'datetime') {
								for (row of rows) {
									if (row[i]) { row[i] = new Date(row[i]) }
								}
							} else if (this.props.data.reportData.graph.columns[i].type === 'number') {
								for (row of rows) {
									if (row[i]) { row[i] = parseInt(row[i], 10) }
								}
							} else if (this.props.data.reportData.graph.columns[i].role === 'tooltip') {
								for (row of rows) {
									if (row[i]) {
										var day = new Date(row[0]).getDay()
										switch (day) {
											case 0:
												day = 'Sunday'
												break;
											case 1:
												day = 'Monday'
												break;
											case 2:
												day = 'Tuesday'
												break;
											case 3:
												day = 'Wednesday'
												break;
											case 4:
												day = 'Thursday'
												break;
											case 5:
												day = 'Friday'
												break;
											case 6:
												day = 'Saturday'
												break;
											default:
												day = null
										}

										var time = new Date(row[0]).toLocaleTimeString()
										row[i] = day + ' ' + time + '<br/> ' + this.props.data.reportData.graph.columns[1].label + ': ' + row[1]
									}
								}
							}
						}
						options = {
							vAxis: { format: 0, gridlines: { count: -1 }, title: this.props.data.reportData.graph.columns[1].label, titleTextStyle: { italic: false, fontSize: 18, color: '#2A6AA9' } },
							chartArea: { width: "90%", height: "70%" },
							legend: { position: 'none' },
							animation: { duration: 500 },
							colors: ['#2A6AA9'], bar: { groupWidth: 15 }, tooltip: { isHtml: true }
						}
						columns = this.props.data.reportData.graph.columns

						//[{type: 'datetime', label: 'Time'},{ type: 'number', label: 'Number of Calls'},{type: 'string', role: 'tooltip', p: {html: true}}]

						options.hAxis = {
							format: 'EEEE',
							gridlines: {
								count: -1,
								units: { days: { format: 'EEEE' } }
							}
						}

						report.push(
							<div className="chart-container" style={{ display: 'inline-block', width: '100%' }}>
								<h2 style={{ textAlign: 'center', color: '#2A6AA9', marginBottom: '0px' }}>{module.title}</h2>
								<Chart
									chartType="ColumnChart"
									columns={columns}
									rows={rows}
									options={options}
									graph_id="historyChart"
									width="100%"
								/>
							</div>
						)
					} else if (this.props.data.reportData.graph.type === 'area') {
						rows = this.props.data.reportData.graph.rows.slice()

						for (i = 0; i < this.props.data.reportData.graph.columns.length; i++) {
							if (this.props.data.reportData.graph.columns[i].type === 'datetime' || this.props.data.reportData.graph.columns[i].type === 'date') {
								for (row of rows) {
									if (row[i]) { row[i] = new Date(row[i]) }
								}
							} else if (this.props.data.reportData.graph.columns[i].type === 'number') {
								for (row of rows) {
									//if(row[i]){row[i] = parseInt(row[i],10)}
								}
							}
						}
						options = {
							vAxis: { gridlines: { count: 0 } },
							series: {
								0: {
									type: "Area",
									areaOpacity: .3
								},
								1: {
									type: "Area",
									areaOpacity: 1
								}
							},
							areaOpacity: 1,
							title: this.props.data.reportData.graph.columns[1].label,
							titleTextStyle: { italic: false, fontSize: 18, color: '#2A6AA9' },
							chartArea: { width: "90%", height: "70%" },
							legend: { position: 'none' },
							isStacked: false,
							animation: { duration: 500 },
							colors: ['#2A6AA9', '#937'], bar: { groupWidth: 15 }, tooltip: { isHtml: true }
						}

						columns = this.props.data.reportData.graph.columns


						report.push(
							<div className="chart-container" style={{ display: 'inline-block', width: '100%' }}>
								<h2 style={{ textAlign: 'center', color: '#2A6AA9', marginBottom: '0px' }}>{module.title}</h2>
								<Chart
									chartType="SteppedAreaChart"
									columns={columns}
									rows={rows}
									options={options}
									graph_id="historyChart"
									width="100%"
								/>
							</div>
						)
					} else if (this.props.data.reportData.graph.type === 'timeline') {
						rows = this.props.data.reportData.graph.rows.slice()

						for (i = 0; i < this.props.data.reportData.graph.columns.length; i++) {
							if (this.props.data.reportData.graph.columns[i].type === 'datetime' || this.props.data.reportData.graph.columns[i].type === 'date') {
								for (row of rows) {
									if (row[i]) { row[i] = new Date(row[i]) }
								}
							} else if (this.props.data.reportData.graph.columns[i].type === 'number') {
								for (row of rows) {
									//if(row[i]){row[i] = parseInt(row[i],10)}
								}
							}
						}
						options = {
							height: 100,
							vAxis: { gridlines: { count: 0 } },
							timeline: {
								showBarLabels: false
							},
							title: this.props.data.reportData.graph.columns[1].label,
							titleTextStyle: { italic: false, fontSize: 18, color: '#2A6AA9' },
							chartArea: { width: "90%", height: "70%" },
							legend: { position: 'none' },
							colors: this.props.data.reportData.graph.colors,
							bar: { groupWidth: 15 },
							tooltip: { isHtml: true }
						}

						columns = this.props.data.reportData.graph.columns


						report.push(
							<div className="chart-container" style={{ display: 'inline-block', width: '100%' }}>
								<h2 style={{ textAlign: 'center', color: '#2A6AA9', marginBottom: '0px' }}>{module.title}</h2>
								<Chart
									chartType="Timeline"
									columns={columns}
									rows={rows}
									options={options}
									graph_id="historyChart"
									width="100%"
									height="100px"
								/>
							</div>
						)
					}
				}

				if (this.props.data.reportData.list) {
					for (var data in this.props.data.reportData.list) {
						if (this.props.data.reportData.list[data] === null) {
							report.push(<div key={data} className="reportRow"></div>)
						} else {
							report.push(<div key={data} className="reportRow">{data + ': ' + this.props.data.reportData.list[data]}</div>)
						}

					}
				}

				if (this.props.data.reportData.table) {
					for (i = 0; i < this.props.data.reportData.table.columns.length; i++) {
						if (this.props.data.reportData.table.columns[i].type === 'datetime') {
							for (row of this.props.data.reportData.table.rows) {
								if (row[i]) { row[i] = new Date(row[i]) }
							}
						} else if (this.props.data.reportData.table.columns[i].type === 'month') {
							this.props.data.reportData.table.columns[i].type = 'number'
							for (row of this.props.data.reportData.table.rows) {
								var months = ["January", 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
								if (row[i] != null) {
									row[i] = { v: row[i], f: months[row[i] - 1] }
								}
							}
						} else if (this.props.data.reportData.table.columns[i].type === 'day') {
							this.props.data.reportData.table.columns[i].type = 'number'
							for (row of this.props.data.reportData.table.rows) {
								var days = ["Sunday", 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
								if (row[i] != null) {
									row[i] = { v: row[i], f: days[row[i] - 1] }
								}
							}
						} else if (this.props.data.reportData.table.columns[i].type === 'hour') {
							this.props.data.reportData.table.columns[i].type = 'number'
							for (row of this.props.data.reportData.table.rows) {
								var hours = ['12:00am', '1:00am', '2:00am', '3:00am', '4:00am', '5:00am', '6:00am', '7:00am', '8:00am', '9:00am', '10:00am', '11:00am', '12:00pm', '1:00pm', '2:00pm', '3:00pm', '4:00pm', '5:00pm', '6:00pm', '7:00pm', '8:00pm', '9:00pm', '10:00pm', '11:00pm']
								if (row[i] != null) {
									row[i] = { v: row[i], f: hours[row[i]] }
								}
							}
						} else if (this.props.data.reportData.table.columns[i].type === 'toNumber') {
							this.props.data.reportData.table.columns[i].type = 'number'
							for (row of this.props.data.reportData.table.rows) {
								row[i] = parseInt(row[i])
							}
						} else if (this.props.data.reportData.table.columns[i].type === 'phone') {
							for (row of this.props.data.reportData.table.rows) {
								this.props.data.reportData.table.columns[i].type = 'string'
								if (row[i]) { row[i] = this.formatPhoneNumber(row[i], 10) }
							}
						} else if (this.props.data.reportData.table.columns[i].type === 'percentage') {
							this.props.data.reportData.table.columns[i].type = 'number'
							for (row of this.props.data.reportData.table.rows) {
								row[i] = { v: row[i], f: row[i] + '%' }
							}
						} else if (this.props.data.reportData.table.columns[i].type === 'timeofday') {
							for (row of this.props.data.reportData.table.rows) {
								if (row[i]) { row[i] = JSON.parse(row[i]) }
							}
						} else if (this.props.data.reportData.table.columns[i].type === 'recording') {
							this.props.data.reportData.table.columns[i].type = 'string'
							for (row of this.props.data.reportData.table.rows) {
								if (row[i]) { row[i] = '<div style="left: Calc(50% - 7.5px); cursor: pointer; position: relative;border-radius: 15px; height: 15px; width: 15px; background-color: #933;" onclick="window.ReportsFunctions.play({sid:\'' + row[i] + '\', callerID: \'' + row[1] + '\' , dateTime:\'' + row[2] + '\' });"></div>' }
							}
						} else if (this.props.data.reportData.table.columns[i].type === 'extraData') {
							this.props.data.reportData.table.columns[i].type = 'string'
							for (row of this.props.data.reportData.table.rows) {

								if (row[i] && row[i] !== 'null' && Object.keys(JSON.parse(row[i])).length > 2) {
									row[i] = '<div style="left: Calc(50% - 7.5px); cursor: pointer; position: relative;border-radius: 15px; height: 15px; width: 15px; background-color: #397;" onclick="window.ReportsFunctions.viewExtraData(\'' + encodeURIComponent(row[i]).replace(/[!'()*]/g, escape) + '\');"></div>'
								} else {
									row[i] = null
								}
							}
						}
					}

					if (this.props.data.reportData.table.rows.length > 0) {
						var dataArray = []
						for (var col of this.props.data.reportData.table.columns) {
							dataArray.push(col.label)
						}
						report.push(<div key="recordCount">{this.props.data.reportData.table.rows.length === 100000 ? 'First 100,000 Records Displayed' : 'Total Records Returned: ' + this.props.data.reportData.table.rows.length}</div>)
						report.push(
							<div key="chartWrapper">
								<Chart
									chartType="Table"
									options={{
										allowHtml: true,
										page: 'enable',
										pageSize: 100,
										pagingButtons: 'auto',
										width: '100%'

									}}
									data={[dataArray].concat(this.props.data.reportData.table.rows)}
									graph_id={"reportTable"}
									chartEvents={[
										{
											eventName: "select",
											callback: this.chartSelect

											// ({ chartWrapper }) {
											// console.log(chartWrapper)
											// console.log(chartWrapper.getChart().getSelection())
											// console.log(this.props.data.reportData.table.rows[chartWrapper.getChart().getSelection()[0].row])
											//console.log("Selected ", chartWrapper.getChart().getSelection());
											//}
										}
									]}
								/>
							</div>
						)
					} else {
						report.push(<div key="noresults">No Results Returned</div>)
					}
				}
			}

			activeReport = (
				<React.Fragment>
					<div style={{ height: '30px', display: 'flex', flexDirection: 'row-reverse' }}>
						{this.props.data.reportData ? <img alt="Excel Icon" src={this.props.img.excel} onClick={this.runReport.bind(this, "excel")} style={{ padding: '0px 15px', cursor: "pointer" }} /> : ''}

						{this.props.data.reportData ? <img alt="CSV Icon" src={this.props.img.csv} onClick={this.runReport.bind(this, "csv")} style={{ padding: '0px 15px', cursor: "pointer" }} /> : ''}

						{false && this.props.data.reportData ? <img alt="PDF Icon" src={this.props.img.pdf} onClick={this.runReport.bind(this, "pdf")} style={{ cursor: "pointer", position: "absolute", top: "50px", right: "192px" }} /> : ''}

						{false && this.props.data.reportData && (!this.props.data.reportData.table || this.props.data.reportData.table.rows.length < 5001) ? <img alt="Print Icon" src={this.props.img.print} onClick={window.print} style={{ cursor: "pointer", position: "absolute", height: "30px", top: "50px", right: "192px" }} /> : ''}
					</div>

					<div style={{ margin: '5px 0px 5px 0px', width: 'auto' }} className="reportHeaders">
						{paramHeaders}
					</div>

					<div style={{ margin: '5px 0px 15px 0px', width: 'auto' }} className="reportFilters">
						{reportParams}
						<div className="button" onClick={this.runReport.bind(this, false)} >Start</div>
					</div>

					{this.props.data.reportLoading ? <div style={{ position: "static", height: "100px" }}><div style={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}><div style={{ margin: "100px" }} className="loader"></div></div></div> : report}

				</React.Fragment >
			)


			var recordingPlayer = ""
			if (this.state.playingRecording) {
				recordingPlayer = (
					<div className="blackout" onClick={this.stopClick}>
						<div className="pop">
							<div className="viewCloser" style={{ display: 'block' }} onClick={this.cancel}></div>
							<div className="loginLabel">Listen to or Download Recording</div>
							<div className="error">{this.state.recordingError}</div>
							{!this.props.data.reportData.recording ? '' : <audio id="recordingPlayer" style={{ width: "500px", height: "50px", margin: "25px" }} src={"https://api.twilio.com" + this.props.data.reportData.recording.replace('.json', '')} download={this.state.activeCall + '.wav'} controls controlsList="nofullscreen nodownload noremoteplayback" />}
							{!this.props.data.reportData.recording ? <div className="loader"></div> : <a style={{ textDecoration: "none" }} href={window.location.origin + '/recording' + this.props.data.reportData.recording.replace('.json', '')} download={this.formatRecordingName(this.state.activeCall)} > <div className="button" >Download Recording</div></a>}
						</div>
					</div>
				)
			}


			var extraDataViewer = ""
			if (this.state.extraData) {
				var dataRows = []
				for (var param in this.state.extraData) {
					if (param != 'twilio') {
						dataRows.push(
							<div style={{ display: 'flex', justifyContent: 'space-between', padding: '25px' }}>
								<div style={{ paddingRight: '25px' }}>{param}:</div>
								<div>{this.state.extraData[param]}</div>
							</div>
						)
					}

				}
				extraDataViewer = (
					<div className="blackout" onClick={this.cancel}>
						<div className="pop" style={{ maxWidth: '90%' }}>
							<div className="viewCloser" style={{ display: 'block' }} onClick={this.cancel}></div>
							<div className="loginLabel">Additional Data</div>
							{dataRows}
						</div>
					</div>
				)
			}
			var reportDetailViewer = ""
			if (this.props.data.reportDetail && this.state.viewingReportDetail) {
				var connectionRows = []
				var flowRows = []
				for (var param in this.props.data.reportDetail.connection) {
					connectionRows.push(
						<div style={{ display: 'flex', justifyContent: 'space-between', padding: '25px' }}>
							<div style={{ paddingRight: '25px' }}>{param}:</div>
							<div>{this.props.data.reportDetail.connection[param]}</div>
						</div>
					)
				}
				for (var metaRow of this.props.data.reportDetail.connectionMeta) {
					connectionRows.push(
						<div style={{ display: 'flex', justifyContent: 'space-between', padding: '25px' }}>
							<div style={{ paddingRight: '25px' }}>{metaRow.Field}:</div>
							<div>{metaRow.Value}</div>
						</div>
					)
				}
				for (var flowRow of this.props.data.reportDetail.flow) {
					for (param in flowRow) {
						flowRows.push(
							<div style={{ display: 'flex', justifyContent: 'space-between', padding: '25px' }}>
								<div style={{ paddingRight: '25px' }}>{param}:</div>
								<div>{flowRow[param]}</div>
							</div>
						)
					}

				}
				reportDetailViewer = (
					<div className="blackout">
						<div className="pop" style={{ maxWidth: '90%' }}>
							<div className="viewCloser" style={{ display: 'block' }} onClick={this.cancel}></div>
							<div className="loginLabel">Connection Data</div>
							{connectionRows}
							<div className="loginLabel">Flow Data</div>
							{flowRows}
						</div>
					</div>
				)
			}

			return (
				<div className="viewContent" id="reportView" >
					<div style={{ overflow: 'auto', height: 'calc(100% - 5px)' }}>
						{activeReport}
					</div>


					{this.state.dateFilter ? <DateFilter data={this.state.parameters.dateFilter} confirmDateFilters={this.confirmDateFilter} cancel={this.cancel} /> : ''}
					{this.state.groupBy ? <GroupBy data={this.state.parameters.groupBy} confirmDateFilters={this.confirmGroupBy} cancel={this.cancel} /> : ''}
					{recordingPlayer}
					{extraDataViewer}
					{reportDetailViewer}
				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}



const icon = "menuChart"
const roles = ["View"]
export { Reporting, icon, roles }